import { getTemplate } from "../template-helper";
import { translateElement, tr } from "../../util/locales" ;
import { waiter } from "../../util/utils";
import { deleteRecord, runInContext } from "../binding";
import { confirm } from "../../util/dialogs";

const COMPONENT_NAME = "z-button-delete" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class ButtonDeleteComponent extends HTMLElement {
            constructor() {
                super();

                this.button = this.querySelector("button") ;
                if(!this.button){
                    const innerHtml = this.innerHTML ;
                    this.innerHTML = "" ;
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                    translateElement(this) ;
                    this.button = this.querySelector("button") ;
                    if(innerHtml){
                        this.button.innerHTML = innerHtml ;
                    }
                }

                
                this.addEventListener("click", ()=>{
                    this.onDelete() ;
                }) ;
            }

            get disabled() {
                return this.button.getAttribute("disabled") ;
            }
            
            set disabled(disabled) {
                this.button.setAttribute("disabled", disabled) ;
            }

            static get observedAttributes() {
                return ['disabled'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'disabled':
                        this.disabled = newValue ;
                    break;
                }
            }

            onDelete(){
                if(!this.form){
                    this.form = this.closest("form");
                }
                if(!this.form){ throw "Button delete should be inside a form" ; }

                let fieldId = "id" ;
                if(this.hasAttribute("z-field-id")){
                    fieldId = this.getAttribute("z-field-id") ;
                }

                let confirmMessage = tr("form.areYouSureDelete") ;
                if(this.hasAttribute("z-confirm")){
                    confirmMessage = this.getAttribute("z-confirm") ;
                }

                confirm(confirmMessage).then((yes)=>{
                    if(!yes){ return ;}
                    waiter(
                        deleteRecord(this.form, fieldId).then((deletedRecord)=>{
                            return new Promise((resolve, reject)=>{
                                let afterDelete = this.getAttribute("z-after-delete") ;
                                if(afterDelete){
                                    const afterDeleteObj = runInContext(this, {deletedRecord}, afterDelete) ;
                                    if(typeof(afterDeleteObj) === "object" && afterDeleteObj.constructor === Promise){
                                        //the result is a promise, wait for it to resolve !
                                        return afterDeleteObj.then(resolve).catch(reject) ;
                                    }else{
                                        return resolve() ;
                                    }
                                }


                                let nextUrl = this.getAttribute("z-next-url") ;
                                if(nextUrl){
                                    const nextUrlFunc = this[nextUrl]||this.form[nextUrl] ;
                                    if(nextUrlFunc){
                                        //this is a function 
                                        let afterSaveObj = nextUrlFunc() ;
                                        if(afterSaveObj){
                                            if(typeof(afterSaveObj) === "string"){
                                                //the result is a string, use it
                                                return resolve(afterSaveObj) ;
                                            }else if(typeof(afterSaveObj) === "object" && afterSaveObj.constructor === Promise){
                                                //the result is a promise, wait for it to resolve !
                                                return afterSaveObj.then(resolve).catch(reject) ;
                                            }
                                        }else{
                                            resolve() ;
                                        }
                                    }else{
                                        resolve(nextUrl.replace("{{id}}", deletedRecord[fieldId])) ;
                                    }
                                }else{
                                    resolve(window.location.href.replace(/\/form\/read.*/, "/list/")) ;
                                }
                            }) ;
                        })
                    ).then((nextUrl)=>{
                        if(nextUrl){
                            window.location.href = nextUrl ;
                        }
                    }) ;
                }) ;
            }
        }
        customElements.define(COMPONENT_NAME, ButtonDeleteComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
